import moment from "moment-timezone";
import momentTimezone from "moment-timezone";

const timeZone = moment.tz.guess(); // Detect user's timezone

// Convert UTC datetime from API to local datetime
export const convertUTCToLocal = (utcString: string) => {
  return moment.utc(utcString).tz(timeZone).format("YYYY-MM-DD HH:mm");
};

export const toZoneDateTime = (dateTime: string) => {
  if (!dateTime) return "";
  return momentTimezone.utc(dateTime).tz(timeZone).format("YYYY-MM-DD:HH:mm");
};

// Convert local datetime from DatePicker to UTC before sending to API
export const toUtcDateTime = (time: string) => {
  if (!time) return "";
  return moment
    .tz(time, "YYYY-MM-DDTHH:mm", timeZone)
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};

export const getTimeZone = (): string | null => {
  return localStorage.getItem("timeZone");
};

export const toZoneDateTimeWithSeconds = (
  dateTime: string | null | undefined
): string => {
  if (!dateTime) return "";

  const timeZone = getTimeZone() || "UTC"; // Default to UTC if null
  return momentTimezone
    .utc(dateTime)
    .tz(timeZone)
    .format("YYYY-MM-DD HH:mm:ss");
};


// for Calender component by h
export const toApiDate = (date: Date) => {
  const timeZone = moment.tz.guess();
  return moment
    .tz(moment(date).format("YYYY-MM-DDT00:00"), "YYYY-MM-DDTHH:mm", timeZone)
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};

// export const getUTCDateString = (date: Date): string => {
//   const yyyy = date.getFullYear();
//   const mm = String(date.getMonth() + 1).padStart(2, '0');
//   const dd = String(date.getDate()).padStart(2, '0');
//   return `${yyyy}-${mm}-${dd}T00:00:00Z`;
// };

//for calender by h-2
export const toApiDate1 = (date: Date) => {
  const localDate = moment(date).format("YYYY-MM-DD");
  return `${localDate}T00:00:00.000Z`;
};

//for startenddate calenders
export const toInputDate = (date: Date) => {
  return moment(date).format("YYYY-MM-DD");
};
// utils/DateRangeUtils.ts
export const isDateRangeValid = (start: Date, end: Date) => {
  const diff = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  return diff < 16; // Valid if ≤ 15 days
};

//For challenges page
export const formatDateRange = (start: string | undefined, end: string | undefined): string => {
  const toISO = (dateStr?: string): string => {
    if (!dateStr || typeof dateStr !== "string") return "";

    // Check if date is already in ISO format
    if (dateStr.includes("T")) return dateStr;

    // Try fixing non-ISO format like "2025-04-23:20:00"
    const fixed = dateStr.replace(":", "T");
    return fixed.length < 19 ? fixed + ":00" : fixed;
  };

  try {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    };

    const startFormatted = new Date(toISO(start)).toLocaleString("en-US", options);
    const endFormatted = new Date(toISO(end)).toLocaleString("en-US", options);

    if (startFormatted === "Invalid Date" || endFormatted === "Invalid Date") {
      return "Date not available";
    }

    return `${startFormatted} to ${endFormatted}`;
  } catch (e) {
    console.error("Date formatting failed:", e, { start, end });
    return "Date error";
  }
};

export const formatDate = (date: string): string => {
  const d = new Date(date);
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
export const parseDurationToMilliseconds = (durationStr: string | null): number => {
  if (!durationStr) return 0;

  // Handle "HH:MM:SS" (0:20:00) or "HH:MM"
  const parts = durationStr.split(':').map(Number);

  let seconds = 0;
  if (parts.length === 3) {
    // Format: HH:MM:SS
    seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
  } else if (parts.length === 2) {
    // Format: HH:MM
    seconds = parts[0] * 3600 + parts[1] * 60;
  }

  return seconds * 1000; // Convert to milliseconds
};
